import { t, Trans } from '@lingui/macro';
import { Field } from '~/app/shared/components/Form';
import { CountryCallingCodeDropdown } from '~/app/shared/components/ui/dropdowns/CountryCallingCodeDropdown/CountryCallingCodeDropdown';
import { CompanyInfoStepState } from '../../types';

export const CompanyInfoFormFields = ({ formInitialData }: { formInitialData: CompanyInfoStepState }) => {
    return (
        <>
            <Field.Text
                id="cvrOrSENumber"
                name="cvrOrSENumber"
                label={t`CVR/SE Number`}
                required
                fieldClassName="w-1/5 p-0"
                readOnly
            />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-3">
                <div className="md:border-r md:pr-3 border-grey-300">
                    <Field.Text
                        id="companyName"
                        name="companyName"
                        label={t`Company name`}
                        required
                        readOnly={!!formInitialData.companyName}
                    />
                    <div className="flex flex-wrap h-18">
                        <div className="w-full text-xs font-bold mb-2">
                            <Trans>Company Phone no. *</Trans>
                        </div>
                        <div className="flex w-full">
                            <Field
                                name="companyCallingCode"
                                fieldClassName="w-2/5 mr-2"
                                initialValue={formInitialData.companyCallingCode}>
                                {({ input }) => (
                                    <CountryCallingCodeDropdown
                                        {...input}
                                        data-testid="company-calling-code-dropdown"
                                        defaultValue={formInitialData.companyCallingCode}
                                    />
                                )}
                            </Field>
                            <Field.Text
                                id="companyPhoneNumber"
                                name="companyPhoneNumber"
                                data-testid="company-phone-number"
                                fieldClassName="w-3/5"
                                type="text"
                                required
                            />
                        </div>
                    </div>

                    <div className="flex items-start">
                        <div className="w-2/5 mr-2">
                            <Field.Text
                                id="postCode"
                                name="postCode"
                                type="text"
                                required
                                label={t`Post code`}
                                readOnly={!!formInitialData.postCode}
                            />
                        </div>
                        <div className="w-3/5">
                            <Field.Text
                                id="city"
                                name="city"
                                type="text"
                                label={t`City`}
                                required
                                readOnly={!!formInitialData.city}
                            />
                        </div>
                    </div>
                    <Field.Text
                        id="address"
                        name="address"
                        type="text"
                        label={t`Address`}
                        required
                        readOnly={!!formInitialData.address}
                    />
                </div>
                <div>
                    <Field.Text
                        id="emailForInvoicing"
                        name="emailForInvoicing"
                        type="email"
                        label={t`E-mail for invoicing`}
                        required
                        readOnly={!!formInitialData.emailForInvoicing}
                    />

                    <Field.Text
                        id="contactPersonName"
                        name="contactPersonName"
                        type="text"
                        label={t`Contact person name`}
                        required
                    />

                    <div className="flex flex-wrap h-18">
                        <div className="w-full text-xs font-bold mb-2">
                            <Trans>Contact person phone no. *</Trans>
                        </div>
                        <div className="flex w-full">
                            <Field
                                name="contactPersonCallingCode"
                                fieldClassName="w-2/5 mr-2"
                                initialValue={formInitialData.contactPersonCallingCode}>
                                {({ input, meta: { error, touched } }) => (
                                    <CountryCallingCodeDropdown
                                        {...input}
                                        data-testid="contact-person-calling-code-dropdown"
                                        invalid={error && touched}
                                        error={error}
                                        defaultValue={formInitialData.contactPersonCallingCode}
                                    />
                                )}
                            </Field>
                            <Field.Text
                                id="contactPersonPhoneNumber"
                                name="contactPersonPhoneNumber"
                                data-testid="contact-person-phone-number"
                                type="text"
                                fieldClassName="w-3/5"
                                required
                            />
                        </div>
                    </div>

                    <Field.Text
                        id="contactPersonEmail"
                        name="contactPersonEmail"
                        label={t`Contact person e-mail`}
                        required
                        type="email"
                    />
                </div>
            </div>
        </>
    );
};
